import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import { memo, useEffect } from "react";
import { useIntl } from "react-intl";
const { TextArea } = Input;

const EditStandingsForm = ({ standings, getStandingsFormData, entityList }) => {
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const initValues = {
    ...standings,
    calculated: JSON.stringify(standings.calculated),
    points: JSON.stringify(standings.points),
  };

  useEffect(() => {
    getStandingsFormData(form);
  }, []);

  return (
    <Form
      form={form}
      labelCol={{
        span: 10,
      }}
      colon={false}
      labelWrap={true}
      initialValues={initValues}
    >
      <Row>
        <Col span={17}>
          <Form.Item
            labelCol={{
              span: 5,
            }}
            name={"entityId"}
            label={formatMessage({
              id: "team",
              defaultMessage: "Team",
            })}
            tooltip={formatMessage({
              id: "form.help.standings.row.team",
              defaultMessage: "The team to add standings data for",
            })}
            rules={[{ required: true }]}
          >
            <Select disabled={true}>
              {entityList?.map((entity) => (
                <Select.Option value={entity.entityId} key={entity.entityId}>
                  {entity.nameFullLocal}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6} offset={1}>
          <Form.Item
            labelCol={{
              span: 14,
            }}
            name={"position"}
            label={formatMessage({
              id: "position",
              defaultMessage: "Position",
            })}
            tooltip={formatMessage({
              id: "form.help.standings.row.position",
              defaultMessage: "The position for the selected team",
            })}
            required={true}
          >
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            name={"calculated"}
            label={formatMessage({
              id: "calculated",
              defaultMessage: "Calculated",
            })}
            tooltip={formatMessage({
              id: "form.help.standings.row.calculated",
              defaultMessage: "The team data calculated points values for the standings",
            })}
          >
            <TextArea rows={6} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            labelCol={{
              span: 4,
            }}
            name={"points"}
            label={formatMessage({
              id: "points",
              defaultMessage: "Points",
            })}
            tooltip={formatMessage({
              id: "form.help.standings.row.points",
              defaultMessage: "The team data points values for the standings",
            })}
          >
            <TextArea rows={6} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default memo(EditStandingsForm);
